import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";
import DropzoneForContact from "../Contacts/DropzoneForContact";
import Images from "../../Images";
import { toast } from "react-toastify";

const EditModel = ({
  editEntryLoading,
  editSingleEntry,
  setOpenEditModel,
  groupId,
  selectedItem,
}) => {
  const InitialValues = {
    id: selectedItem?.id,
    firstName: selectedItem?.first_name,
    lastName: selectedItem?.last_name,
    mobile: selectedItem?.mobile,
    email: selectedItem?.email,
    groupId,
  };

  const SubmitHandler = (values) => {
    if (values.mobile.length != 9) {
      return toast.error("Please enter a valid 9 digit mobile number");
    }
    editSingleEntry(values);
  };

  return (
    <Model width={`w-11/12 max-w-xl `} setOpenModel={setOpenEditModel}>
      <Title>Edit Contact</Title>

      {editEntryLoading && <Loading />}

      {!editEntryLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              <InputGroup>
                <Label htmlFor="firstName">First Name</Label>
                <FieldWrapper>
                  <Field
                    type="text"
                    name="firstName"
                    id="firstName"
                    autoComplete="off"
                    className="truncate"
                    required
                  />
                </FieldWrapper>
              </InputGroup>
              <InputGroup>
                <Label htmlFor="lastName">Last Name</Label>
                <FieldWrapper>
                  <Field
                    type="text"
                    name="lastName"
                    id="lastName"
                    autoComplete="off"
                    className="truncate"
                    required
                  />
                </FieldWrapper>
              </InputGroup>
              <InputGroup>
                <Label htmlFor="mobile">Phone Number</Label>
                <FieldWrapper>
                  <Field
                    type="text"
                    name="mobile"
                    id="mobile"
                    autoComplete="off"
                    className="truncate"
                    required
                  />
                </FieldWrapper>
              </InputGroup>
              <InputGroup>
                <Label htmlFor="email">Email</Label>
                <FieldWrapper>
                  <Field
                    type="email"
                    name="email"
                    id="email"
                    autoComplete="off"
                    className="truncate"
                    required
                  />
                </FieldWrapper>
              </InputGroup>
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;
const SampleFile = tw.a` w-full pt-3 text-blue-500 underline text-sm text-center`;

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center`;

export default EditModel;
